export const ACTION = {
  RequestLoadDraftsCount: 'CASE_DRAFT_INFO:REQUEST_LOAD_DRAFTS_COUNT',
  ReceiveLoadDraftsCount: 'CASE_DRAFT_INFO:RECEIVE_LOAD_DRAFTS_COUNT',
  FailLoadDraftsCount: 'CASE_DRAFT_INFO:FAIL_LOAD_DRAFTS_COUNT'
};

export class RequestLoadDraftsCount {
  public type: string = ACTION.RequestLoadDraftsCount;
}

export class ReceiveLoadDraftsCount {
  public type: string = ACTION.ReceiveLoadDraftsCount;
  constructor(public count: number) {}
}

export class FailLoadDraftsCount {
  public type: string = ACTION.FailLoadDraftsCount;
}
